<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Fore">F<span class="small">OREWORD</span></p>
<p class="para1">I met Mark Supley through his father, Bob, who always attends my wildly popular Lost Speedways programs at the Saratoga Automobile Museum.</p>
<p class="para">The Supleys are both ardent racing fans and knew me through my writing for <i>National Speed Sport News</i>, <i>Stock Car</i>, <i>Open Wheel</i>, and <i>Speedway Illustrated</i> magazines and the <i>Schenectady Gazette</i>. As I came to know them, it became apparent that while Mark liked auto racing, his primary reason for living is motorcycle racing in all its shapes and forms.</p>
<p class="para">From there, becoming my resident expert on all things motorcycle was a quick and, for my audience, providential jump. Each summer, fans and racers at the region’s speedways bombard me with questions about the upcoming Lost Speedways, and the number one question is always some variation of “What’s that crazy motorcycle guy going to talk about this year?”</p>
<p class="para">Mark has raced scrambles, competed on area short tracks and on the region’s frozen lakes with both racing bikes and a sidecar, has done sand drags, hill climbs, and has even tried observed trials, so he knows what he speaks of when he talks motorcycle racing.</p>
<p class="para">A restoration expert as well, he has used skills honed as an assembler at the huge General Electric facility in Schenectady to restore his 1926 Harley-Davidson to a level that earned him the Antique Motorcycle Club of America’s national Best Restored Antique Award, with the gorgeous Harley currently on display at the Motorcyclepedia Museum in Newburgh, New York. Mark’s other restorations include a 1975 Kawasaki 250cc Short Tracker and a 1976 Honda 550 Super Sport.</p>
<p class="para">There is no reason to believe that his first book will be any less impressive than his other motorcycle-related accomplishments, because he has lived the stories. Let’s get started.</p>
<p class="right">— Ron Hedger</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?084ba1c5